import * as React from 'react';
import { Navigate } from 'react-router-dom';
import '../../../hmilib/hmiglobal';
import useDynamicSVGImport from '../../../useDynamicSVGImport';
import { Alarm } from '@mui/icons-material';

interface iTopMenu {}

const TopMenu = (props: iTopMenu) => {
    const [svgTop, setSvgTop] = React.useState('');
    //ссылка на аудио
    const [audioSrc, setAudioSrc] = React.useState('');

    React.useEffect(() => {
        fetch('/ixyber/vision/dcs/centumvp/centumvptop.svg')
            .then((response) => response.text())
            .then((svg) => setSvgTop(svg));
    }, []);

    React.useEffect(() => {
        const updateTopMenu = () => {
            const dateTimeElement = document.getElementById('textDateTime');
            if (dateTimeElement) {
                let date = new Date();
                let month = (date.getMonth() + 1).toString().padStart(2, '0');
                let day = date.getDate().toString().padStart(2, '0');
                let year = date.getFullYear();
                let hours = date.getHours().toString().padStart(2, '0');
                let minutes = date.getMinutes().toString().padStart(2, '0');

                dateTimeElement.textContent = `${day}.${month}.${year} ${hours}:${minutes}`;
            }

            let CountAlarms = document.getElementById('CountAlarms');
            if (CountAlarms) CountAlarms.textContent = window.Base.Events.GetActiveEvents().CentumVP.AL.NoAckCount;

            let countSA = document.getElementById('tspan4297');
            if (countSA) countSA.textContent = window.Base.Events.GetActiveEvents().CentumVP.SA.NoAckCount;

            let countOG = document.getElementById('countOG');
            if (countOG) countOG.textContent = window.Base.Events.GetActiveEvents().CentumVP.OG.NoAckCount;

            let propertyNameBlink = 'opacity';

            let statusAL = document.getElementById('statusAL');
            if (statusAL != null) {
                statusAL.style.opacity =
                    window.Base.Events.GetActiveEvents().CentumVP.AL.Messages.length != 0 ? '1' : '0';

                if (window.Base.Events.GetActiveEvents().CentumVP.AL.NoAckCount != 0 && statusAL.style.animation == '')
                    statusAL.style.animation = 'blink-animation-opacity 1s ease-in-out infinite';
                else if (
                    window.Base.Events.GetActiveEvents().CentumVP.AL.NoAckCount == 0 &&
                    statusAL.style.animation != ''
                )
                    statusAL.style.animation = '';
                /*
                if(window.Base.Events.GetActiveEvents().CentumVP.AL.NoAckCount != 0){
                    let flickerAttr = statusAL.getAttribute("flicker-condition")
                    let oldblink = (flickerAttr) ? JSON.parse(flickerAttr) : {};
                    if (oldblink[propertyNameBlink] === undefined) {
                        oldblink[propertyNameBlink] = {};
                        oldblink[propertyNameBlink].enable = false;
                    }

                    if(!oldblink[propertyNameBlink].enable){
                        oldblink[propertyNameBlink].value = 0;
                        oldblink[propertyNameBlink].enable = true;
                        oldblink[propertyNameBlink].normValue = 1;
                        statusAL.setAttribute("flicker-condition", JSON.stringify(oldblink));
                    }

                }else{
                    let flickerAttr = statusAL.getAttribute("flicker-condition")
                    let oldblink = (flickerAttr) ? JSON.parse(flickerAttr) : {};
                    if (oldblink[propertyNameBlink] === undefined) {
                        oldblink[propertyNameBlink] = {};
                        oldblink[propertyNameBlink].enable = false;
                    }

                    if(oldblink[propertyNameBlink].enable){
                        oldblink[propertyNameBlink].value = 0;
                        oldblink[propertyNameBlink].enable = false;
                        oldblink[propertyNameBlink].normValue = 1;
                        statusAL.setAttribute("flicker-condition", JSON.stringify(oldblink));
                    }

                }
                */
            }

            let statusSA = document.getElementById('statusSA');
            if (statusSA) {
                statusSA.style.opacity =
                    window.Base.Events.GetActiveEvents().CentumVP.SA.Messages.length != 0 ? '1' : '0';

                if (window.Base.Events.GetActiveEvents().CentumVP.SA.NoAckCount != 0 && statusSA.style.animation == '')
                    statusSA.style.animation = 'blink-animation-opacity 1s ease-in-out infinite';
                else if (
                    window.Base.Events.GetActiveEvents().CentumVP.SA.NoAckCount == 0 &&
                    statusSA.style.animation != ''
                )
                    statusSA.style.animation = '';

                /*
                if(window.Base.Events.GetActiveEvents().CentumVP.SA.NoAckCount != 0){
                    let flickerAttr = statusSA.getAttribute("flicker-condition")
                    let oldblink = (flickerAttr) ? JSON.parse(flickerAttr) : {};
                    if (oldblink[propertyNameBlink] === undefined) {
                        oldblink[propertyNameBlink] = {};
                        oldblink[propertyNameBlink].enable = false;
                    }

                    if(!oldblink[propertyNameBlink].enable){
                        oldblink[propertyNameBlink].value = 0;
                        oldblink[propertyNameBlink].enable = true;
                        oldblink[propertyNameBlink].normValue = 1;
                        statusSA.setAttribute("flicker-condition", JSON.stringify(oldblink));
                    }

                }else{
                    let flickerAttr = statusSA.getAttribute("flicker-condition")
                    let oldblink = (flickerAttr) ? JSON.parse(flickerAttr) : {};
                    if (oldblink[propertyNameBlink] === undefined) {
                        oldblink[propertyNameBlink] = {};
                        oldblink[propertyNameBlink].enable = false;
                    }

                    if(oldblink[propertyNameBlink].enable){
                        oldblink[propertyNameBlink].value = 0;
                        oldblink[propertyNameBlink].enable = false;
                        oldblink[propertyNameBlink].normValue = 1;
                        statusSA.setAttribute("flicker-condition", JSON.stringify(oldblink));
                    }

                }
                */
            }

            let statusOG = document.getElementById('statusOG');
            if (statusOG) {
                statusOG.style.opacity =
                    window.Base.Events.GetActiveEvents().CentumVP.OG.Messages.length != 0 ? '1' : '0';

                if (window.Base.Events.GetActiveEvents().CentumVP.OG.NoAckCount != 0 && statusOG.style.animation == '')
                    statusOG.style.animation = 'blink-animation-opacity 1s ease-in-out infinite';
                else if (
                    window.Base.Events.GetActiveEvents().CentumVP.OG.NoAckCount == 0 &&
                    statusOG.style.animation != ''
                )
                    statusOG.style.animation = '';

                /*
                if(window.Base.Events.GetActiveEvents().CentumVP.OG.NoAckCount != 0){
                    let flickerAttr = statusOG.getAttribute("flicker-condition")
                    let oldblink = (flickerAttr) ? JSON.parse(flickerAttr) : {};
                    if (oldblink[propertyNameBlink] === undefined) {
                        oldblink[propertyNameBlink] = {};
                        oldblink[propertyNameBlink].enable = false;
                    }

                    if(!oldblink[propertyNameBlink].enable){
                        oldblink[propertyNameBlink].value = 0;
                        oldblink[propertyNameBlink].enable = true;
                        oldblink[propertyNameBlink].normValue = 1;
                        statusOG.setAttribute("flicker-condition", JSON.stringify(oldblink));
                    }

                }else{
                    let flickerAttr = statusOG.getAttribute("flicker-condition")
                    let oldblink = (flickerAttr) ? JSON.parse(flickerAttr) : {};
                    if (oldblink[propertyNameBlink] === undefined) {
                        oldblink[propertyNameBlink] = {};
                        oldblink[propertyNameBlink].enable = false;
                    }

                    if(oldblink[propertyNameBlink].enable){
                        oldblink[propertyNameBlink].value = 0;
                        oldblink[propertyNameBlink].enable = false;
                        oldblink[propertyNameBlink].normValue = 1;
                        statusOG.setAttribute("flicker-condition", JSON.stringify(oldblink));
                    }

                }*/
            }

            //Отображение 3-x алармов на верхней панели
            if (window.Base.Events.GetActiveEvents().CentumVP.TopNoAck3 != undefined) {
                const topNoAck3 = window.Base.Events.GetActiveEvents().CentumVP.TopNoAck3;

                if (topNoAck3.length < 3) {
                    for (let i = 3; i > topNoAck3.length; i--) {
                        const alarm = document.getElementById(`alarm${i}`);
                        if (alarm) {
                            ['alarm-icon', 'alarm-folder', 'alarm-error', 'alarm-condition-name'].forEach((id) => {
                                const element = alarm.querySelector(`#${id}`);
                                if (element) element.innerHTML = '';
                            });
                        }
                    }
                }

                if (topNoAck3.length != 0) {
                    topNoAck3.map((param: any, index: any) => {
                        const alarm = document.getElementById(`alarm${index + 1}`);
                        if (alarm) {
                            let alarmIcon = alarm.querySelector('#alarm-icon');
                            let alarmFolder = alarm.querySelector(`#alarm-folder`);
                            let alarmError = alarm.querySelector(`#alarm-error`);
                            let alarmCond = alarm.querySelector(`#alarm-condition-name`);

                            if (alarmIcon) alarmIcon.innerHTML = param.alarm;
                            if (alarmFolder) alarmFolder.innerHTML = param.folder;
                            if (alarmError) alarmError.innerHTML = param.error;
                            if (alarmCond) alarmCond.innerHTML = param.conditionName;

                            (alarm as HTMLElement).onclick = () => window.OpenFaceplateTun(param.folder);
                        }
                    });
                }
            }

            //Sound
            if (window.Base.Events.GetActiveEvents().CentumVP.TopNoAck3[0] != undefined) {
                let alarm = window.Base.Events.GetActiveEvents().CentumVP.TopNoAck3[0];

                if (alarm.eventCategory <= 3) {
                    //AL
                    if (alarm.recover) {
                        playAlarmSound('ProcessAlarmRecover');
                    } else {
                        if (alarm.priority >= 801 && alarm.priority <= 1000) {
                            playAlarmSound('ProcessAlarmHigh');
                        } else if (alarm.priority >= 201 && alarm.priority <= 800) {
                            playAlarmSound('ProcessAlarmMedium');
                        }
                    }
                } else if (alarm.eventCategory >= 4 && alarm.eventCategory <= 6) {
                    //SA
                    playAlarmSound('SystemAlarm');
                }
            } else {
                playAlarmSound('');
            }
        };

        updateTopMenu();

        const intervalId = setInterval(updateTopMenu, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const [canPlayAudio, setCanPlayAudio] = React.useState(false);

    React.useEffect(() => {
        const handleMouseMove = () => {
            setCanPlayAudio(true);
        };

        window.addEventListener('click', handleMouseMove);

        return () => {
            window.removeEventListener('click', handleMouseMove);
        };
    }, []);

    const playAlarmSound = (soundType: any) => {
        let soundSrc;
        switch (soundType) {
            case 'ProcessAlarmRecover':
                soundSrc = '/ixyber/vision/dcs/centumvp/audio/ProcessAlarmRecover.mp3';
                break;
            case 'ProcessAlarmHigh':
                soundSrc = '/ixyber/vision/dcs/centumvp/audio/ProcessAlarmHigh.mp3';
                break;
            case 'ProcessAlarmMedium':
                soundSrc = '/ixyber/vision/dcs/centumvp/audio/ProcessAlarmMedium.mp3';
                break;
            case 'SystemAlarm':
                soundSrc = '/ixyber/vision/dcs/centumvp/audio/SystemAlarm.mp3';
                break;

            default:
                soundSrc = '';
                break;
        }

        setAudioSrc(soundSrc);
    };

    React.useEffect(() => {
        const audioElement = document.getElementById('alarmSound') as HTMLAudioElement;
        if (audioSrc == '' && canPlayAudio) {
            audioElement.pause();
        }
        if (audioElement && audioSrc && canPlayAudio) {
            audioElement.src = audioSrc;
            audioElement.muted = false;
            audioElement.play();
        }
    }, [audioSrc, canPlayAudio]);

    return (
        <header className="centumvp_topmenu">
            <div dangerouslySetInnerHTML={{ __html: svgTop }} />
            <audio autoPlay loop src={audioSrc} id="alarmSound"></audio>
        </header>
    );
};

export default TopMenu;
